import { isMissingTranslation, translate } from '@utils/i18n';
import { DAY_BRIEF_CARD_DEFAULT_TEXT, DAY_BRIEF_CARD_NAMESPACE } from './constants';
// A host with no translation for a key gets a placeholder back (the namespaced key, or
// i18n-js's `[missing "..."]`), so fall back to English rather than render it.
export function dayBriefCardText(key, params = {}) {
    const text = translate(key, Object.assign({ namespace: DAY_BRIEF_CARD_NAMESPACE }, params));
    if (!isMissingTranslation(text, `${DAY_BRIEF_CARD_NAMESPACE}.${key}`))
        return text;
    return DAY_BRIEF_CARD_DEFAULT_TEXT[key].replace(/%\{(\w+)\}/g, (match, name) => { var _a; return (_a = params[name]) !== null && _a !== void 0 ? _a : match; });
}
const TIME_SPAN_SEPARATOR = /\s+[–—-]\s+/;
const PHONE_EXTENSION_MARKER = /\s*(?:ext\.?|x)\s*\d.*$/i;
const NON_DIALABLE = /[^\d+]/g;
/** "7:30 – 9:00 AM" → start "7:30", end "9:00 AM". A single time has no end. */
export function splitTimeSpan(span) {
    const [start, ...rest] = span.split(TIME_SPAN_SEPARATOR);
    return { start, end: rest.length > 0 ? rest.join(' – ') : null };
}
/**
 * `tel:` href for a displayed phone number, or null when it holds no digits.
 * An extension ("x12") cannot ride along in a tel: URI portably, so it is dropped
 * rather than merged into the number.
 */
export function telHref(phone) {
    const dialable = phone.replace(PHONE_EXTENSION_MARKER, '').replace(NON_DIALABLE, '');
    return /\d/.test(dialable) ? `tel:${dialable}` : null;
}
